module.exports = __webpack_public_path__ + "static/media/oneProductMainImg.dcb25f14.png";